// src/utils/exportToPDF.js
// تصدير جدول بيانات إلى ملف PDF
// المكتبات المطلوبة: npm install jspdf jspdf-autotable

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// columns: [{ header: 'الاسم', key: 'name' }, ...]
export function exportToPDF(data, columns, title = 'تقرير', fileName = 'تقرير') {
  if (!data || data.length === 0) {
    alert('لا توجد بيانات لتصديرها');
    return;
  }
  const doc = new jsPDF();
  doc.setFontSize(14);
  doc.text(title, 14, 15);

  autoTable(doc, {
    startY: 22,
    head: [columns.map((c) => c.header)],
    body: data.map((row) => columns.map((c) => row[c.key] ?? '')),
    styles: { font: 'helvetica', fontSize: 10 },
    headStyles: { fillColor: [99, 102, 241] },
  });

  doc.save(`${fileName}.pdf`);
}
